import { redrawFragment } from '@wheelbox/lithejs-engine';
import { FormControl } from '../../model/form';
import { validateControl } from './validate-control';

export default function onInputHandler(value: string, control: FormControl) {
  control.value = value;
  control.touched = true;
  control.valid = validateControl(control);

  redrawFragment(`${control.id}-error-message`);
}
